import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 100%;
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 50%;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  border-radius: 10px;
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 20px;
  padding: 70px 110px;
  box-shadow: 0 2px 15px -5px #000;
`

export const Input = styled.input``

export const VendorName = styled.p`
  font-size: 1.2rem;
`
export const VendorLabel = styled.h2`
  font-size: 1.4rem;
`
export const Label = styled.label`
  display: flex;
  flex-direction: column;
  font-weight: bold;
`

export const Title = styled.h1``

export const SubmitButton = styled.input`
  width: 200px;

  outline-color: #002d63;
  padding: 20px 5px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  color: #ffffff;
  background-color: ${({ disabled }) => (disabled ? '#bbbbbb' : ' #25a37b')};
  cursor: pointer;
  font-weight: bold;
`

const BaseButton = styled.button`
  width: 200px;

  outline-color: #002d63;
  padding: 20px 5px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  color: #ffffff;
  background-color: ${({ disabled }) => (disabled ? '#bbbbbb' : ' #e63c22')};
  cursor: pointer;
  font-weight: bold;
`

export const GreenButton = styled(BaseButton)`
  background-color: ${({ disabled }) => (disabled ? '#bbbbbb' : ' #25a37b')};
`

export const RedButton = styled(BaseButton)`
  background-color: ${({ disabled }) => (disabled ? '#bbbbbb' : ' #e63c22')};
`

export const WrapperVendor = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`
